export const GET_BIKE_VARIANTS_REQUEST = 'GET_BIKE_VARIANTS_REQUEST';
export const GET_BIKE_VARIANTS_SUCCESS = 'GET_BIKE_VARIANTS_SUCCESS';
export const GET_BIKE_VARIANTS_FAILURE = 'GET_BIKE_VARIANTS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/constants/get_bike_variants.constants.js